module.exports = __webpack_public_path__ + "img/scene5-17.ad1286b6.png";